export default "__VITE_ASSET__BlKQNfAM__"